import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getEvaluationScale } from '../api';
import { EvaluationScalesResponse } from '../types';
import { useParams } from 'react-router-dom';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  EvaluationScalesResponse,
  AxiosResultDefaultError
>();

export function useSurveyEvaluationScaleLoader() {
  return useFetch();
}

export const SurveyEvaluationScaleLoaderConsumer = FetchConsumer;

export default function SurveyEvaluationScaleLoader({
  children,
}: BaseLoaderProps) {
  const { scaleId } = useParams<{ scaleId: string }>();
  const request = useCallback(() => getEvaluationScale(scaleId), [scaleId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
